function downloadImage(data, fileName, type="image/gif") {
  
  fetch(data)
    .then(res => res.blob()) // Gets the response and returns it as a blob
    .then(blob => {
    // Here's where you get access to the blob
    // And you can use it for whatever you want
    // Like calling ref().put(blob)

    // Here, I use it to make an image appear on the page
    let objectURL = window.URL.createObjectURL(blob);

    //Create an invisible A element
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    a.href = objectURL;
    
    // Use download attribute to set set desired file name
    a.setAttribute("download", fileName);

    // Trigger the download by simulating click
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }); 
}
